import { Injectable } from '@angular/core';
import { ITratta } from '../models/tratta';
import { IS1RicercaStandardParams, IS1TypedPaginatedResult, S1ApiCrudService, S1HttpClientService } from '@app/s1';
import { map, Observable } from 'rxjs';
import { IStazione, IStazioneTratta } from '../models/stazione';

export interface IRicercaTrattaParams extends IS1RicercaStandardParams, Partial<ITratta> { 
  idStazione?: string
}
export interface IRicercaStazioneTrattaParams extends IS1RicercaStandardParams, Partial<IStazione> { 
  idStazione?: string
}


export interface IAssociaStazioneParams {
  idTratta: string,
  idStazione: string
}

export interface IDisassociaStazioneParams extends IAssociaStazioneParams { }

export enum TrattaAPI {
  associaStazione = "/:idTratta/stazione/associa",
  disassociaStazione = "/:idTratta/stazione/:idStazione/disassocia",
  ricercaStazione = "/:idTratta/stazione/ricerca"
}

@Injectable({
  providedIn: 'root'
})
export class TrattaService extends S1ApiCrudService<ITratta, IRicercaTrattaParams> {

  constructor(s1HttpClient: S1HttpClientService) { 
    super(s1HttpClient, "/tratta");
  }

  associaStazione(params: IAssociaStazioneParams): Observable<boolean> {

    const idTratta = params.idTratta;
    delete params.idTratta;

    return this.s1HttpClient.post(`${this.path}${TrattaAPI.associaStazione.replace(":idTratta", idTratta)}`, params).pipe(
      map(response => {
        return response.outcome.success
      })
    )
  } 

  disassociaStazione(params: IDisassociaStazioneParams): Observable<boolean> {
    return this.s1HttpClient.delete(`${this.path}${TrattaAPI.disassociaStazione.replace(":idTratta", params.idTratta).replace(":idStazione", params.idStazione)}`).pipe(
      map(response => {
        return response.outcome.success
      })
    )
  }

  ricercaStazione(params: IRicercaStazioneTrattaParams): Observable<IS1TypedPaginatedResult<IStazioneTratta>> {

    const idTratta = params.id;
    delete params.id;

    return this.s1HttpClient.post(`${this.path}${TrattaAPI.ricercaStazione.replace(":idTratta", idTratta)}`, params).pipe(
      map(response => {
        return  { 
          elements: response.results,
          paginationInfo: response.paginationInfo
        } as IS1TypedPaginatedResult<IStazione>
      })
    )
  } 

}